import NotFound from './NotFound.vue';
import { messages } from 'src/i18n/i18n';
import attributesRoutes from '../attributes/attributes.routes';
import homeRoutes from '../home/home.routes';
import locationsRoutes from '../locations/locations.routes';
import workInstructionsRoutes from '../work-instructions/work-instructions.routes';
import usersRoutes from '../users/users.routes';
import rolesRoutes from '../roles/roles.routes';
import { RouterViewSlider } from '../components/RouterViewSlider';
import contextRoutes from '../context/context.routes';
import linkRoutes from '../links/link.routes';
import { materialRoutes } from '../material/material.routes';
import scheduleRoutes from '../schedules/schedule.routes';
import { authInitialized, validateAcls } from '../auth';
import { processRoutes } from 'src/processes/processes.routes';
import { workOrderRoutes } from 'src/work-order/workOrder.routes';
import { validateRoleSelectAcl } from 'src/roles/roles.validations';
import performanceRoutes from 'src/performance/performance.routes';
import { RouteConfig } from 'vue-router';
import { appletRoutes } from 'src/applet/applet.routes';
import connectionRoutes from 'src/connections/connections.routes';

// collect and merge routes from core pages
export const routes: RouteConfig[] = [
    {
        path: '/',
        component: () => import(/* webpackChunkName: "main" */ '../DefaultLayout.vue'),
        name: 'main',
        redirect: { name: 'home' },
        meta: {
            transition: 'vertical',
        },
        beforeEnter (to, from, next) {
            authInitialized.then(() => { // TODO cancel if auth fails, but should probably allow `home`
                next();
            });
        },
        children: [
            ...homeRoutes,
            ...appletRoutes,
            ...connectionRoutes,
            ...attributesRoutes,
            ...locationsRoutes,
            ...materialRoutes,
            ...processRoutes,
            ...workOrderRoutes,
            ...workInstructionsRoutes,
            ...scheduleRoutes,
            ...performanceRoutes,
            {
                name: 'adminNavGrp',
                path: 'admin',
                redirect: { name: 'contextList' },
                component: RouterViewSlider,
                meta: {
                    navbarGroupOnly: true,
                    navigationGuard: () => validateRoleSelectAcl() || validateRoleSelectAcl(),
                    navbarTitle: 'Admin',
                    navbarIcon: 'mdi-shield-star-outline',
                    transition: 'vertical',
                    featureFlags: [],
                },
                children: [
                    ...contextRoutes,
                    ...rolesRoutes,
                    ...usersRoutes,
                    {
                        name: 'apiPanel',
                        path: '/redirect-api-panel',
                        redirect () {
                            return '/api/trpc/panel';
                        },
                        meta: {
                            navbarIcon: 'mdi-engine',
                            navbarTitle: 'API Panel',
                            navigationGuard: () => validateAcls([ 'k8s_dashboard_ro' ]),
                            featureFlags: [ 'api' ],
                            onClick () {
                                window.open('/api/trpc/panel', '_blank');
                            },
                        },
                    },
                    {
                        name: 'gqlPlayground',
                        path: '/gql-playground',
                        meta: {
                            navbarIcon: 'mdi-graphql',
                            navbarTitle: 'GQL Playground',
                            pageBannerTitle: 'GQL',
                            pageBannerSubtitle: 'Playground',
                            navigationGuard: () => validateAcls([ 'gql_playground_visible' ]),
                            featureFlags: [ 'api' ],
                        },
                        component: () => import(/* webpackChunkName: "main" */ '../components/GqlPlayground/GqlPlayground.vue'),
                    },
                ],
            },
            ...linkRoutes,
            {
                name: 'helpLink',
                path: '/docs',
                meta: {
                    navbarIcon: 'mdi-help-box',
                    navbarTitle: 'Documentation',
                    featureFlags: [],
                    onClick: () => location.href = '/docs/',
                },
            },
            {
                path: '/not-found',
                name: '404',
                component: NotFound,
                meta: {
                    pageBannerTitle: messages.pageNotFound,
                    featureFlags: [],
                },
            },
        ],
    },
    {
        path: '/applet-runtime-inspect/:runnerId/:deploymentId/:designId',
        name: 'AppletInspection',
        component: () => import(/* webpackChunkName: "main" */ '../applet/inspection/AppletInspection.vue'),
        meta: {
            featureFlags: [ 'applets' ],
        },
    },
    {
        path: '*',
        redirect: { name: '404' },
    },
];
